import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import './MainLayout.css';

const MainLayout = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/app', icon: '🏠', label: 'Главная', exact: true },
    { path: '/app/workouts', icon: '💪', label: 'Тренировки' },
    { path: '/app/calculator', icon: '🍎', label: 'Калории' },
    { path: '/app/coach', icon: '🤖', label: 'AI Тренер' },
    { path: '/app/progress', icon: '📊', label: 'Прогресс' },
  ];

  const isActive = (path, exact) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="main-layout">
      {/* Top Header */}
      <header className="app-header">
        <div className="header-content">
          <Link to="/" className="header-logo">
            <span className="logo-text">
              <span className="logo-fit">FIT</span>
              <span className="logo-house">HOUSSE</span>
            </span>
          </Link>
          <Link to="/app/profile" className="profile-button">
            <span className="profile-icon">👤</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="app-main">
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      <nav className="bottom-nav">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default MainLayout;
